<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    beforeCreate() {
      switch (window.location.hostname) {
        case 'stressless-beratertage.at':
        case 'stressless-beratertage.ch':
        case 'stressless-beratertage.de':
        case 'localhost':
        default:
          this.$i18n.locale = 'de';
      }
    },

    mounted() {
      window.CookieConsent.init({
        // More link URL on bar
        modalMainTextMoreLink: null,
        // How lond to wait until bar comes up
        barTimeout: 1000,
        // Look and feel
        theme: {
          barColor: '#ffffff',
          barTextColor: '#2D2F79',
          barMainButtonColor: '#2D2F79',
          barMainButtonTextColor: '#FFF',
          modalMainButtonColor: '#2D2F79',
          modalMainButtonTextColor: '#FFF',
        },
        language: {
          // Current language
          current: 'de',
          locale: {
            en: {
              barMainText: 'Wenn Sie auf „Alle Cookies akzeptieren“ klicken, stimmen Sie der Speicherung von Cookies auf Ihrem Gerät zu, um die Websitenavigation zu verbessern, die Websitenutzung zu analysieren und unsere Marketingbemühungen zu unterstützen. Unter "Cookie-Einstellungen" können Sie eine individuelle Auswahl treffen und erteilte Einwilligungen jederzeit für die Zukunft widerrufen. Hiervon ausgenommen sind technisch notwendige Cookies. Weitere Informationen zu Cookies finden Sie in unserer Datenschutzerklärung.',
              barLinkSetting: 'Cookie Einstellungen',
              barBtnAcceptAll: 'Alle Cookies akzeptieren',
              modalMainTitle: 'Cookie Einstellungen',
              modalMainText: 'Wenn Sie eine Website besuchen, kann diese Informationen über Ihren Browser abrufen oder speichern. Dies geschieht meist in Form von Cookies. Hierbei kann es sich um Informationen über Sie, Ihre Einstellungen oder Ihr Gerät handeln. Meist werden die Informationen verwendet, um die erwartungsgemäße Funktion der Website zu gewährleisten. Durch diese Informationen werden Sie normalerweise nicht direkt identifiziert. Dadurch kann Ihnen aber ein personalisierteres Web-Erlebnis geboten werden. Da wir Ihr Recht auf Datenschutz respektieren, können Sie sich entscheiden, bestimmte Arten von Cookies nicht zulassen. Klicken Sie auf die verschiedenen Kategorieüberschriften, um mehr zu erfahren und unsere Standardeinstellungen zu ändern. Die Blockierung bestimmter Arten von Cookies kann jedoch zu einer beeinträchtigten Erfahrung mit der von uns zur Verfügung gestellten Website und Dienste führen.',
              modalBtnSave: 'Aktuelle Einstellungen speichern',
              modalBtnAcceptAll: 'Alles akzeptieren und schließen',
              modalAffectedSolutions: 'Affected solutions:',
              learnMore: 'Mehr erfahren',
              on: 'An',
              off: 'Aus',
            }
          }
        },
        // List all the categories you want to display
        categories: {
          // Unique name
          // This probably will be the default category
          necessary: {
            // The cookies here are necessary and category cant be turned off.
            // Wanted config value  will be ignored.
            needed: true,
            // The cookies in this category will be let trough.
            // This probably should be false if not necessary category
            wanted: true,
            // If the checkbox is on or off at first run.
            checked: true,
            // Language settings for categories
            language: {
              locale: {
                de: {
                  name: 'Technische Cookies',
                  description: 'Diese Cookies sind technisch notwendig und können nicht ausgeschalten werden. Hiermit handelt es sich um keine analytische Daten.',
                }
              }
            }
          },
          marketing: {
            needed: false,
            wanted: false,
            checked: false,
            language: {
              locale: {
                de: {
                  name: 'Marketing',
                  description: 'Nicht vorhanden',
                }
              }
            }
          },
        },
      });

      document.addEventListener("DOMContentLoaded", function() {
        let newButton = document.createElement('button');
        newButton.innerHTML = "Alle Cookies ablehnen";
        newButton.classList.add('consent-decline-button');

        let ccbButton = document.getElementsByClassName('ccb__button')[0];
        ccbButton.appendChild(newButton);

        newButton.addEventListener("click", function () {
          document.getElementById('cconsent-bar').style.display = "none";
        });
      });
    }
  }
</script>

<style lang="scss">
  $lato-font-path: "~@/fonts/lato";

  @font-face {
    font-family: "Lato-Light";
    src: url("#{$lato-font-path}/Lato-Light.ttf") format("truetype");
    font-weight: 300;
  }
  @font-face {
    font-family: "Lato";
    src: url("#{$lato-font-path}/Lato-Regular.ttf") format("truetype");
    font-weight: 400;
  }

  @font-face {
    font-family: "Lato-Bold";
    src: url("#{$lato-font-path}/Lato-Bold.ttf") format("truetype");
    font-weight: 700;
  }

  #app {
    font-family: 'Lato', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  #cconsent-bar {
    border-top: solid 1px #2c7cbf;

    button {
      width: 100%;
      max-width: 550px;
    }

    .ccb__right {
      width: 100%;

      > div.ccb__button {
        display: flex;
        align-items: center;
      }
    }

    a.ccb__edit {
      line-height: normal;
      font-size: 14px;
      border: 1px solid #2c7cbf;
      padding: 10px 10px;
      color: #2C7CBF;
      background-color: #FFF;
    }
  }

  .consent-decline-button {
    margin: 10px;
  }

  .ccm__tab-content__left {
    display: none;
  }
</style>
